export class ServizioStampa {
  titolo: string;
  testo: string;
  testoFormattato: string;
  tipo: string;
  portale: boolean = true;

  orderNum: number; //deprecated
  modello: boolean; //deprecated

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}



// WEBPACK FOOTER //
// ./src/app/models/ServizioStampa.ts